import { Component, OnInit } from '@angular/core';
import { UsefulLinkService } from '../../../services/useful-link.service';
import { UsefulLink } from '../../../models/useful-link';

@Component({
  selector: 'app-useful-links-dashboard',
  templateUrl: './useful-links-dashboard.component.html',
  styleUrls: ['./useful-links-dashboard.component.scss'],
  providers: [ UsefulLinkService ]
})
export class UsefulLinksDashboardComponent implements OnInit {

  usefulLinks: Array<UsefulLink> = [];
  lastEvaluatedKey: any;

  constructor(private usefulLinkService: UsefulLinkService) { }

  ngOnInit() {
    this.getAll(null);
  }

  getNext() {
    this.getAll(this.lastEvaluatedKey);
  }

  getAll(lastEvaluatedKey?: string): void {
    this.usefulLinkService
      .getAll(lastEvaluatedKey)
      .subscribe((usefulLinks) => {
        this.usefulLinks = this.usefulLinks && lastEvaluatedKey ?
                           this.usefulLinks.concat(usefulLinks.Items) : usefulLinks.Items;
        this.lastEvaluatedKey = usefulLinks.LastEvaluatedKey;

      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/useful-links-dashboard/useful-links-dashboard.component.ts